import Presenter from './Presenter';
import { IContainerProps } from './types';

const HomeContainer = (props: IContainerProps) => {

    return (
        <Presenter
            {...props}
        />
    );
};

export default HomeContainer;
